import React from 'react';
import { Box, Container, Typography, Grid, IconButton, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';

const footerLinks = [
  { label: 'Portfolio', to: '/startups' },
  { label: 'Who We Are', to: '/about-us' },
  { label: 'Investors', to: '/investors' },
  { label: 'Entrepreneurs', to: '/entrepreneurs' },
  { label: 'Research & Media', to: '/knowledge-center' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Glossary', to: '/glossary' },
  { label: 'Jobs', to: '/jobs' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
];

const socialLinks = [
  { icon: <EmailIcon />, href: 'mailto:team@iangels.com', label: 'Email' },
  { icon: <XIcon />, href: 'https://twitter.com/iaborAngels', label: 'X' },
  { icon: <FacebookIcon />, href: 'https://facebook.com/iAngels', label: 'Facebook' },
  { icon: <LinkedInIcon />, href: 'https://linkedin.com/company/iangels', label: 'LinkedIn' },
  { icon: <InstagramIcon />, href: 'https://instagram.com/iangels', label: 'Instagram' },
];

const MarketingFooter = () => (
  <Box component="footer" sx={{ backgroundColor: '#0a3d3d', color: 'white', py: 6 }}>
    <Container maxWidth="lg">
      <Grid container spacing={4}>
        {/* Left column */}
        <Grid item xs={12} md={4}>
          <Typography variant="h5" sx={{ fontWeight: 700, fontFamily: 'Georgia, serif', mb: 2 }}>
            iAngels™
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.85, lineHeight: 1.8 }}>
            +972 3 901 3760
            <br />
            team@iangels.com
            <br />
            Rothschild Blvd 18
            <br />
            Tel Aviv 6688121
          </Typography>
        </Grid>

        {/* Right column – links grid */}
        <Grid item xs={12} md={8}>
          <Grid container spacing={1}>
            {footerLinks.map((link) => (
              <Grid item xs={6} sm={4} key={link.to}>
                <MuiLink
                  component={Link}
                  to={link.to}
                  underline="hover"
                  sx={{ color: 'white', opacity: 0.85, display: 'block', py: 0.5, fontSize: '0.95rem', '&:hover': { opacity: 1 } }}
                >
                  {link.label}
                </MuiLink>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>

      {/* Social icons */}
      <Box sx={{ display: 'flex', gap: 1, mt: 4, mb: 2 }}>
        {socialLinks.map((s) => (
          <IconButton
            key={s.label}
            component="a"
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={s.label}
            sx={{ color: 'white', opacity: 0.8, '&:hover': { opacity: 1 } }}
            size="small"
          >
            {s.icon}
          </IconButton>
        ))}
      </Box>

      {/* Copyright */}
      <Typography variant="body2" sx={{ opacity: 0.6, mt: 2 }}>
        © 2026 • All rights reserved
      </Typography>
    </Container>
  </Box>
);

export default MarketingFooter;
